"use client";

import { useRouter } from "next13-progressbar";
import Error400 from "../components/error/400";

export default function NotFound() {
  const router = useRouter();
  return <Error400 statusCode={404} onClick={() => router.replace("/")} />;
}
